import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: [],
  manuallySelectedStops: [],
  previousStopIndex: null,
  criteria: [],
};

const stopFiltersSlice = createSlice({
  name: 'stopFilters',
  initialState,
  reducers: {
    updateFilters(state, action) {
      state.manuallySelectedStops = action.payload.stopIds;
      state.filters = action.payload.filters;
      state.criteria = [];
    },
    updateSelectedStops(state, action) {
      state.manuallySelectedStops = action.payload;
    },
    setPreviousStopIndex(state, action) {
      state.previousStopIndex = action.payload;
    },
    clearSelection(state) {
      state.filters = [];
      state.criteria = [];
      state.manuallySelectedStops = [];
    },
    setCriteriaValue(state, action) {
      state.filters = [];
      state.manuallySelectedStops = action.payload.selectedStopIds;
      state.criteria = action.payload.criteria;
    },
  },
});

export const {
  updateFilters,
  updateSelectedStops,
  setPreviousStopIndex,
  clearSelection,
  setCriteriaValue,
} = stopFiltersSlice.actions;

export default stopFiltersSlice.reducer;
